import React, { useState, useEffect } from "react";
import { Router, Link, Redirect } from "@reach/router";
import InfoNavBar from "./InfoNavBar";
import { GoujianList } from "./listpage";
import { GoujianDetail } from "./detailpage";
import { WenxianPage } from "./wenxianpage";
import { TestPage } from "./testpage";
import { TiaowenPage } from "./tiaowenpage";
import { hasRole, authWrapper, LoginModalPage } from "../../../auth";

function InfoRouter(props) {
  return (
    <>
      <Router primary={false}>
        <InfoNavBar path="goujians/" nav="goujians" />
        <InfoNavBar path="wenxians/" nav="wenxians" />
        <InfoNavBar path="tiaowens/" nav="tiaowens" />
        <InfoNavBar path="test/" nav="test" />
      </Router>

      <Router>
        <GoujianList path="goujians/" initRenderNumber={6} />
        <GoujianDetail path="goujian/:goujianId/*" />
        <WenxianPage path="wenxians/" />
        <TiaowenPage path="tiaowens/" />

        {hasRole(["学生", "教师"]) && (
          <TestPage path="test/" number={20} score={5} />
        )}
        {hasRole(["访客"]) && <LoginModalPage path="test/" />}

        {/* <GoujianImages path="goujian/goujianimages/:goujianId/*" />

      <GoujianTiaowens path="goujian/goujiantiaowens/:goujianId/*" /> */}

        <Redirect from="*" to="/info/goujians/" noThrow />
      </Router>
    </>
  );
}
export default InfoRouter;
